import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { Mode } from '@/common/entityFramework/enumerations/Mode';

const astGpSideNav = {
  id: 'gp',
  children: [
    {
      id: 'gpGlRecon',
      displayName: 'GL Reconciliation',
      icon: fas.faFileInvoiceDollar,
      role: 'GP_GL_RECON_VIEW',
      route: 'gp/gl-recon',
      state: { mode: Mode.PERSPECTIVE }
    },
  ]
};

export default astGpSideNav;